import { Component, OnInit, AfterViewInit } from '@angular/core';

declare var $: any;

@Component({
  selector: 'app-smart-buildings',
  templateUrl: './smart-buildings.component.html',
  styleUrls: ['./smart-buildings.component.css']
})
export class SmartBuildingsComponent implements OnInit, AfterViewInit {

  constructor() { }

  ngOnInit() {
  }

  ngAfterViewInit(): void {

    // slide the content 
    $(window).scroll(function () {
      $(".slideanim").each(function () {
        var pos = $(this).offset().top;
        var winTop = $(window).scrollTop();
        if (pos < winTop + 780) {
          $(this).addClass("slide");
        }
      });
    });
  }

}
